import otpVerification from './OtpVerification';

export default otpVerification;
